<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">ບໍລິສັດທີ່ເລືອກໄດ້ຖືກ ແບັກລິສ</p>
        <!-- <button class="delete" aria-label="close"></button> -->
      </header>
      <section class="modal-card-body">
        <ul>
          <li>
            <label>ວັນທີ່ຖືກແັບກລິສ:
              <p>{{ createdAt }}</p>
            </label>
          </li>
          <li>
            <label>ເຫດຜົນທີ່ຖືກແບັກລິສ </label>
            <fieldset>
              {{ reasonBlacklist }}
            </fieldset>
          </li>
          <li v-if="files.length">
            <label>ຫຼັກຖານ</label>
            <fieldset>
              <label class="file-placeholder" v-for="(i, index) in files" :key="index">
                <img :src="$urlImageShow + i" alt="" />
              </label>
            </fieldset>
          </li>
        </ul>
      </section>
      <footer class="modal-card-foot">
        <button class="button primary" @click="$emit('cancel')">ຮັບຊາບ</button>
      </footer>
    </div>
  </div>
</template>

<script>
import { apolloClient } from "@/services/apollo-client";
import { BLACKLISTINFO } from "@/graphql/blacklist/blacklist";
export default {
  props: ['id'],
  data() {
    return {
      createdAt: "",
      reasonBlacklist: "",
      files: []
    }
  },
  methods: {
    async fetch() {
      const form = {
        employerId: this.id,
      };
      const res = await apolloClient.query({
        query: BLACKLISTINFO,
        variables: form,
      });
      const i = res.data.blackListInfo;
      this.createdAt = i.createdAt
      this.reasonBlacklist = i.reasonBlacklist
      this.files = i.files
    }
  },
  created() {
    // setTimeout(() => {
    this.fetch()
    // }, 500)
  }
};
</script>

<style lang="scss" scoped>
.alert-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 8;

  .alert-modal-bg {
    background-color: rgba(#000, 0.8);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

.modal-card-head {
  padding: 30px;

  .modal-card-title {
    font-weight: 700;
    color: var(--text-color);
  }
}

.modal-card-body {
  padding: 30px;

  ul {
    list-style-type: none;
    margin: 0;

    li {
      list-style-type: none;

      label {
        display: flex;
        margin-bottom: 10px;

        p {
          margin-left: 10px;
          font-weight: 700;
          color: var(--text-color);
        }
      }

      fieldset {
        border: 1px solid var(--border-color);
        padding: 10px;

        .file-placeholder {
          content: "";
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          border: 1px solid var(--border-color);
          background-color: var(--light-grey-color);
          cursor: pointer;
          aspect-ratio: 16/10;
          position: relative;

          img {
            aspect-ratio: 16/10;
            width: 100%;
            object-fit: cover;
            display: block;
          }
        }
      }
    }

    // li
  }
}

.modal-card-foot {
  padding: 30px;
}
</style>
